const MainSearch = class extends HTMLElement {
  constructor() {
    super();

    // Clicking close button
    this.querySelectorAll('.main-search__close').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
      });
    });

    // Pressing escape key
    this.querySelector('.main-search__input').addEventListener('keyup', (evt) => {
      if (evt.key === 'Escape') {
        this.querySelector('.main-search__close').dispatchEvent(new Event('click'));
      }
    });

    // Apply filter logic to form submission
    const form = this.querySelector('.main-search__form');
    if (form) {
      form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    // Search as you type (if enabled)
    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }
  }

  // Centralized filter logic
  applyFilters(searchTerm) {
    const productTypes = [
      { singular: 'earring', plural: 'earrings', filter: 'Earrings' },
      { singular: 'necklace', plural: 'necklaces', filter: 'Necklaces' },
      { singular: 'anklet', plural: 'anklets', filter: 'Anklets' },
      { singular: 'bracelet', plural: 'bracelets', filter: 'Bracelets' },
      { singular: 'brooch', plural: 'brooches', filter: 'Brooches' },
      { singular: 'ring', plural: 'rings', filter: 'Rings' }
    ];

    let url = '/search?q=' + encodeURIComponent(searchTerm);
    for (const type of productTypes) {
      if (searchTerm.toLowerCase().includes(type.singular) || searchTerm.toLowerCase().includes(type.plural)) {
        //url += `&filter.p.product_type=${type.filter}&sort_by=relevance`;
        //url += `&sort_by=relevance`;
        break;
      }
    }
    return url;
  }

  // Handle form submission
  handleSubmit(event) {
    event.preventDefault();
    const searchInput = this.querySelector('#search-input') || this.querySelector('.main-search__input');
    const searchTerm = searchInput.value.trim();
    const url = this.applyFilters(searchTerm);
    window.location.href = url;
  }

  initQuickSearch() {
    const searchInput = this.querySelector('.main-search__input');
    const searchTimeoutThrottle = 500;
    const resultLimit = 8;
    const includeMeta = this.dataset.quickSearchMeta === 'true';
    let searchTimeoutID = -1;
    let searchAbortController = null;

    const handleInputChange = () => {
      const resultsBox = this.querySelector('.main-search__results');
      const valueToSearch = searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        this.oldSearchValue = valueToSearch;

        if (searchAbortController !== null) {
          searchAbortController.abort('Existing request not needed');
          searchAbortController = null;
        }

        clearTimeout(searchTimeoutID);

        const form = searchInput.closest('form');
        const linkURL = new URL(form.action);
        const formParams = new URLSearchParams(new FormData(form));
        formParams.forEach((value, key) => { linkURL.searchParams.set(key, value); });

        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
        this.classList.add('main-search--loading');
        if (!this.querySelector('.main-search__results-spinner')) {
          resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';
        }

        searchTimeoutID = setTimeout(() => {
          searchAbortController = new AbortController();
          let ajaxUrl = this.applyFilters(valueToSearch); // Apply filters to quick search URL

          if (theme.Shopify.features.predictiveSearch) {
            ajaxUrl = new URL(theme.routes.base + theme.routes.predictiveSearch);
            ajaxUrl.searchParams.set('q', valueToSearch);
            ajaxUrl.searchParams.set('section_id', 'predictive-search');
            ajaxUrl.searchParams.set('resources[limit]', resultLimit);
            ajaxUrl.searchParams.set('resources[options][fields]', includeMeta ? 'title,product_type,variants.title,vendor,tag,variants.sku' : 'title,product_type,variants.title,vendor');
          } else {
            ajaxUrl = new URL(ajaxUrl); // Use filtered URL
            ajaxUrl.searchParams.set('section_id', 'main-search');
          }

          fetch(ajaxUrl, { method: 'get', signal: searchAbortController.signal })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then((response) => {
              const template = document.createElement('template');
              template.innerHTML = response;
              let resultsList = null;
              if (theme.Shopify.features.predictiveSearch) {
                resultsList = template.content.querySelector('.product-grid');
              } else {
                resultsList = template.content.querySelector('.section-search-template .product-grid');
              }

              searchAbortController = null;
              this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
              resultsBox.innerHTML = '';

              const resultsProducts = document.createElement('div');
              resultsProducts.className = 'main-search__results__products collection-listing';
              resultsProducts.innerHTML = '<div></div>';
              const resultsPages = document.createElement('div');
              resultsPages.className = 'main-search__results__pages';

              resultsProducts.firstElementChild.className = resultsList.className;

              resultsList.querySelectorAll('.product-block:not(.collection-block):not(.page-block)').forEach((block, index) => {
                if (index <= resultLimit) {
                  block.classList.add('main-search-result');
                  block.querySelectorAll('.btn.quickbuy-toggle').forEach((el) => el.remove());
                  block.querySelectorAll('.quickbuy-toggle').forEach((el) => el.classList.remove('quickbuy-toggle'));
                  resultsProducts.firstElementChild.appendChild(block);
                }
              });

              resultsList.querySelectorAll('.product-block.page-block').forEach((block) => {
                const item = document.createElement('a');
                item.className = 'main-search-result main-search-result--page';
                item.href = block.querySelector('a').href;
                item.innerHTML = '<div class="main-search-result__text"></div>';
                item.firstElementChild.innerText = block.querySelector('.page-block__title').innerText;
                resultsPages.appendChild(item);
              });

              this.classList.remove('main-search--loading');

              const areProducts = !!resultsProducts.querySelector('.main-search-result');
              const arePages = !!resultsPages.querySelector('.main-search-result');
              if (areProducts || arePages) {
                this.classList.add('main-search--has-results');
                this.classList.toggle('main-search--results-on-multiple-lines', resultsProducts.querySelectorAll('.product-block').length > 4);
                if (areProducts) {
                  resultsBox.appendChild(resultsProducts);
                }
                if (arePages) {
                  const heading = document.createElement('h6');
                  heading.className = 'main-search-result__heading';
                  heading.innerHTML = theme.strings.generalSearchPages;
                  resultsPages.insertAdjacentElement('afterbegin', heading);
                  resultsBox.appendChild(resultsPages);
                }

                const allLink = document.createElement('a');
                allLink.className = 'main-search__results-all-link btn btn--secondary';
                allLink.href = this.applyFilters(valueToSearch); // Use filtered URL for "View All"
                allLink.innerHTML = theme.strings.generalSearchViewAll;
                resultsBox.appendChild(allLink);
              } else {
                this.classList.add('main-search--no-results');
                const emptyMessage = document.createElement('div');
                emptyMessage.className = 'main-search__empty-message';
                emptyMessage.innerHTML = theme.strings.generalSearchNoResultsWithoutTerms;
                resultsBox.appendChild(emptyMessage);
              }
            })
            .catch((error) => {
              console.warn(error);
            });
        }, searchTimeoutThrottle);
      } else if (!valueToSearch.length) {
        this.oldSearchValue = valueToSearch;
        if (searchAbortController !== null) {
          searchAbortController.abort('Existing request not needed');
          searchAbortController = null;
        }
        clearTimeout(searchTimeoutID);

        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--loading');
        resultsBox.innerHTML = '';
      }
    };

    searchInput.addEventListener('keyup', handleInputChange.bind(this));
    searchInput.addEventListener('change', handleInputChange.bind(this));
  }
};

window.customElements.define('main-search', MainSearch);


document.addEventListener('DOMContentLoaded', function() {
  function attachSearchListeners() {
    const searchForms = document.querySelectorAll('.main-search__form');
    searchForms.forEach(function(form) {
      // Skip if listener is already attached (avoid duplicates)
      if (form.dataset.listenerAdded) return;
      
      form.addEventListener('submit', function(event) {
        event.preventDefault();
        const searchInput = form.querySelector('#search-input') || form.querySelector('.main-search__input');
        if (!searchInput) return; // Exit if no input found
        
        const searchTerm = searchInput.value.trim().toLowerCase();
        let url = '/search?q=' + encodeURIComponent(searchTerm);

        const productTypes = [
          { singular: 'earring', plural: 'earrings', filter: 'Earrings' },
          { singular: 'necklace', plural: 'necklaces', filter: 'Necklace' },
          { singular: 'anklet', plural: 'anklets', filter: 'Anklet' },
          { singular: 'bracelet', plural: 'bracelets', filter: 'Bracelet' },
          { singular: 'brooch', plural: 'brooches', filter: 'Brooches %26 Pins' },
          { singular: 'ring', plural: 'rings', filter: 'Ring' }
        ];

        for (const type of productTypes) {
          if (searchTerm.includes(type.singular) || searchTerm.includes(type.plural)) {
            url += `&filter.p.product_type=${type.filter}&sort_by=relevance`;
            break;
          }
        }

        window.location.href = url;
      });
      
      // Mark form as processed
      form.dataset.listenerAdded = 'true';
    });
  }

  // Run initially
  attachSearchListeners();

  // Watch for dynamically added forms (e.g., secondary search on /search page)
  const observer = new MutationObserver(function() {
    attachSearchListeners();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
